export const COPAY_ALL_CLAIMS_TABLE = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Submitted',
  },
  {
    value: '',
    label: 'Patient',
  },
  {
    value: '',
    label: 'Product',
  },
  {
    value: '',
    label: 'Submitting Practice',
  },
  {
    value:'',
    label:'Status'
  },
  {
    value:'',
    label:'Copay'
  },
  
  {
    value:'',
    label:'Next Steps'
  },
  {
    value:'',
    label:'Days Left '
  },
];
